import { useContext, useMemo, useState } from "react";
import { useTable } from "react-table";
import primaryComponents from "../../../primaryComponents";
import { DeleteIcon } from "../../../../assets/svgIcons";
import { useTestTerminalConnection } from "../../../../hooks/api/mutations/useTerminals";
import { ToastContext } from "../../../../hooks/context";
import { useNavigate, useSearchParams } from "react-router-dom";
import { pathConstants } from "../../../../routes/pathContants";

export const useIntegratedDeviceList = ({ deviceList }) => {
  const [terminalDetails, setTerminalDetails] = useState(null);
  const [deleteTerminalDetails, setDeleteTerminalDetails] = useState(null);
  const [testId, setTestId] = useState(null);
  const triggerToast = useContext(ToastContext);
  const navigate = useNavigate();
  const [search] = useSearchParams();

  const { mutate: testConnection, isLoading: isTestingConnection } =
    useTestTerminalConnection();
  const handleTestConnection = (id) => {
    setTestId(id);
    testConnection(
      { data: {}, id },
      {
        onSuccess: () => {
          triggerToast("Connection is Active", "success");
        },
        onSettled: () => setTestId(null),
      },
    );
  };

  const columns = useMemo(
    () => [
      {
        Header: "Serial Number",
        accessor: "terminal_sn",
        Cell: ({ cell: { value } }) => value || "N/A",
      },
      {
        Header: "Terminal ID",
        accessor: "terminal_id",
        Cell: ({ cell: { value } }) => value || "N/A",
      },
      {
        Header: "Merchant ID",
        accessor: "merchant_id",
        Cell: ({ cell: { value } }) => value || "N/A",
      },
      {
        Header: "Store ID",
        accessor: "store",
        Cell: ({ cell: { value } }) => value?.name || "N/A",
      },
      {
        Header: "Enabled On Checkout",
        accessor: "use_on_checkout",
        Cell: ({ cell: { value } }) => (value ? "Yes" : "No"),
      },
      {
        Header: "Action",
        Cell: ({ row }) => (
          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
            {search.get("terminal_type") !== "OPAY" ? (
              <primaryComponents.Button
                onClick={() => handleTestConnection(row?.original?.id)}
                isDisabled={isTestingConnection && testId === row?.original?.id}
                isLoading={isTestingConnection && testId === row?.original?.id}
                loadingText={"Testing..."}
                classNames={"btn btn--success smallBtn"}
              >
                Test Connection
              </primaryComponents.Button>
            ) : null}
            <primaryComponents.Button
              onClick={() =>
                navigate(
                  pathConstants.APPS_INTEGRATION_TERMINALS_CONNECT_EDIT({
                    id: row?.original?.id,
                  }) + `?terminal_type=${search.get("terminal_type")}`,
                )
              }
              classNames={"btn btn--primary smallBtn"}
            >
              Update
            </primaryComponents.Button>
            <span
              className="cursor-pointer"
              onClick={() => setDeleteTerminalDetails(row?.original)}
            >
              <DeleteIcon />
            </span>
          </div>
        ),
      },
    ],
    [isTestingConnection, testId],
  );

  const instance = useTable({ columns, data: deviceList });
  return {
    instance,
    terminalDetails,
    deleteTerminalDetails,
    setDeleteTerminalDetails,
    setTerminalDetails,
  };
};
